import { useKeepAlive } from './use-keep-alive';

const KeepAlive = () => {
    useKeepAlive();
    return null;
};

export default KeepAlive;
